import {
  SectionHeading,
  SelectField,
} from "@via/pages/projects/metadata/configuration/data-import/components/fields";
import {
  IMPORT_INTERVAL_OPTIONS,
  type ImportFormValues,
} from "@via/pages/projects/metadata/configuration/data-import/utils/form";
import type { FC } from "react";

const ScheduleSection: FC<{
  values: ImportFormValues;
  onChange: (patch: Partial<ImportFormValues>) => void;
}> = ({ values, onChange }) => (
  <section aria-labelledby="import-schedule-heading" className="space-y-4">
    <SectionHeading id="import-schedule-heading" title="Schedule" />
    <label className="flex items-center gap-2 text-sm text-gray-900">
      <input
        type="checkbox"
        checked={values.autoUpdate}
        onChange={event => onChange({ autoUpdate: event.target.checked })}
      />
      Run automatically
    </label>
    <SelectField
      id="import-interval"
      label="Interval"
      value={String(values.autoUpdateInterval)}
      onChange={value => onChange({ autoUpdateInterval: Number(value) })}
      options={IMPORT_INTERVAL_OPTIONS.map(option => ({
        value: String(option.value),
        label: option.label,
      }))}
    />
  </section>
);

export default ScheduleSection;
